<template lang="pug">
  v-dialog(
    v-model="show",
    transition="slide-y-reverse-transition",
    persistent,
    max-width="450")
    v-card.pa-3
      v-card-title.text-xs-center
        h3 Редактирование
      v-card-text
        v-form(ref="forms")
          span.upperLine Новое название
          v-text-field(
            :error-messages="error",
            outline,
            flat,
            single-line,
            v-model="name")
          div(v-if="queryTitle")
            span.upperLine запрос
            v-text-field(
              outline,
              flat,
              single-line,
              v-model="query")
      v-card-actions
        v-spacer
        v-btn(large @click.prevent="cancel").mx-3 Отмена
        v-btn(
          large
          color="primary",
          :loading="loading",
          :disabled="disableBtn",
          @click.prevent="edit").mx-3 Сохранить
        v-spacer
</template>

<script>
export default {
  name: 'EditDb',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dbName: {
      type: String,
      default: ''
    },
    queryTitle: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  created() {
    this.subscribeToMutations()
  },
  data: () => ({
    name: '',
    query: null,
    disableBtn: true,
    error: ''
  }),
  watch: {
    dbName(val) {
      if (val) this.name = val
    },
    queryTitle(val) {
      if (val) this.query = val
    },
    name(val, oldVal) {
      // console.log('val: ', JSON.stringify(val).length)
      // console.log('old-val: ', JSON.stringify(oldVal).length)
      this.disableBtn = val.length !== oldVal.length + 1 && val.length + 1 !== oldVal.length
    },
    query(val, oldVal) {
      this.disableBtn = val.length !== oldVal.length + 1 && val.length + 1 !== oldVal.length
    }
  },
  computed: {
    loading() {
      return this.$store.state.dbConstructor.loading.editDbNameLoading
    }
  },
  methods: {
    cancel() {
      this.$emit('close-edit-db-name-dialog')
      this.error = ''
      this.name = ''
      this.query = null
    },
    edit() {
      this.$store.dispatch('EDIT_DB_NAME', {
        id: this.id,
        name: this.name,
        query: this.query
      })
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'EDIT_DB_NAME_SUCCESS':
            this.cancel()
            break
          case 'EDIT_DB_NAME_ERROR':
            let error = this.$store.state.constructor.errors.editDbNameError
            this.error = error
            break
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Constructor/EditDb.vue